// extracted by mini-css-extract-plugin
export default {"button":"NavCSS_button__VLpH5","active":"NavCSS_active__GWBd6"};